var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-block"},[_c('label',{staticClass:"info-label"},[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"info-value"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }